import { useEffect } from 'react';
import {
    FaUser,
    FaTools,
    FaProjectDiagram,
    FaCertificate,
    FaExternalLinkAlt,
    FaCode,
    FaDatabase,
    FaToolbox,
    FaWhatsapp,
    FaLinkedin,
    FaGithub
} from 'react-icons/fa';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './SobreMi.css';
import SEO from '../Componentes/seo';

function SobreMi() {
    const structuredData = {
        "@context": "https://schema.org",
        "@type": "AboutPage",
        name: "Sobre mí | Juan Camilo Muñoz",
        url: "https://portafoliojcmr.netlify.app/sobremi",
        description:
            "Perfil profesional de Juan Camilo Muñoz, desarrollador web en Colombia con experiencia en React, Node.js, bases de datos y diseño web."
    };

    useEffect(() => {
        AOS.init({ duration: 1200, once: true });
    }, []);

    return (
        <div className="sobre-mi-container">
            <SEO
                title="Sobre mí, Juan Camilo Muñoz"
                description="Conoce el perfil de Juan Camilo Muñoz: desarrollador web con enfoque en React, Node.js, frontend, backend, bases de datos y creación de sitios web para negocios."
                path="/sobremi"
                keywords={[
                    "sobre mí",
                    "Juan Camilo Muñoz",
                    "desarrollador web",
                    "React",
                    "Node.js",
                    "bases de datos",
                    "Colombia"
                ]}
                structuredData={structuredData}
            />
            <aside className="menu-lateral">
                <ul>
                    <li>
                        <a href="#quien-soy">
                            <FaUser className="icono-menu" /> Quién Soy
                        </a>
                    </li>
                    <li>
                        <a href="#habilidades">
                            <FaTools className="icono-menu" /> Habilidades
                        </a>
                    </li>
                    <li>
                        <a href="#proyectos">
                            <FaProjectDiagram className="icono-menu" /> Proyectos
                        </a>
                    </li>
                    <li>
                        <a href="#experiencia">
                            <FaCertificate className="icono-menu" /> Certificados
                        </a>
                    </li>
                </ul>
            </aside>

            <main className="contenido-principal">
                <section id="quien-soy" className="seccion quien-soy-fila" data-aos="fade-up">
                    <div className="perfil-fila">
                        <img src="/imgs/foto.jpg" alt="Foto de perfil" className="foto-perfil-fila" />
                        <div className="descripcion-fila">
                            <h1>Juan Camilo Muñoz</h1>
                            <p>
                                Soy un desarrollador web apasionado por crear soluciones modernas,
                                eficientes y visualmente atractivas. Me especializo en tecnologías como React,
                                Node.js, bases de datos y diseño web. Mi objetivo es construir
                                aplicaciones que no solo funcionen bien, sino que también brinden una
                                experiencia de usuario de alto nivel.
                            </p>

                            <div className="iconos-sociales">
                                <a href="https://wa.me/573154484804" target="_blank" rel="noopener noreferrer"><FaWhatsapp /></a>
                                <a href="https://www.linkedin.com/in/juancamilomunozr/" target="_blank" rel="noopener noreferrer"><FaLinkedin /></a>
                                <a href="https://github.com/" target="_blank" rel="noopener noreferrer"><FaGithub /></a>
                            </div>
                        </div>
                    </div>
                </section>

                <section id="habilidades" className="seccion" data-aos="fade-right">
                    <h2>Habilidades</h2>
                    <div className="listado-personalizado">
                        <div className="item-lista">
                            <FaCode className="icono-item" /> Frontend: React, HTML5, CSS3, JavaScript
                        </div>
                        <div className="item-lista">
                            <FaCode className="icono-item" /> Backend: Node.js, Express
                        </div>
                        <div className="item-lista">
                            <FaDatabase className="icono-item" /> Bases de Datos: FreeSQL, Azure, WixData, Supabase
                        </div>
                        <div className="item-lista">
                            <FaToolbox className="icono-item" /> Herramientas: Git, Netlify, Vercel, Figma
                        </div>
                    </div>
                </section>

                <section id="proyectos" className="seccion" data-aos="fade-left">
                    <h2>Proyectos</h2>
                    <div className="listado-personalizado">
                        <div className="item-lista">
                            <a href="https://jcmrfitness.netlify.app/" target="_blank" rel="noopener noreferrer" className="enlace-proyecto">
                                <FaExternalLinkAlt className="icono-item" /> JCMR FITNESS: Tienda virtual de ropa deportiva y suplementos
                            </a>
                        </div>
                        <div className="item-lista">
                            <a href="https://tcelmec.netlify.app/" target="_blank" rel="noopener noreferrer" className="enlace-proyecto">
                                <FaExternalLinkAlt className="icono-item" /> TCELEMEC: Portafolio de servicio técnico y profesional
                            </a>
                        </div>
                        <div className="item-lista">
                            <a href="https://dataprocontrol.com/" target="_blank" rel="noopener noreferrer" className="enlace-proyecto">
                                <FaExternalLinkAlt className="icono-item" /> DATAPROCONTROL: ERP para control óptimo de la producción
                            </a>
                        </div>
                    </div>
                </section>

                <section id="experiencia" className="seccion" data-aos="fade-up">
                    <h2>Certificados</h2>
                    <div className="listado-personalizado">
                        <div className="item-lista"><FaCertificate className="icono-item" /> Ingeniero Mecánico - Universidad Industrial de Santander</div>
                        <div className="item-lista"><FaCertificate className="icono-item" /> Maestría en Administración de Proyectos - ENEB</div>
                        <div className="item-lista"><FaCertificate className="icono-item" /> Fundamentos de Marketing Digital - Google</div>
                        <div className="item-lista"><FaCertificate className="icono-item" /> Curso de JavaScript: Manipulación del DOM - Platzi</div>
                        <div className="item-lista"><FaCertificate className="icono-item" /> Curso de JavaScript: Web Components - Platzi</div>
                        <div className="item-lista"><FaCertificate className="icono-item" /> Curso de Frontend Developer - Platzi</div>
                        <div className="item-lista"><FaCertificate className="icono-item" /> Curso de Responsive Design - Platzi</div>
                        <div className="item-lista"><FaCertificate className="icono-item" /> Curso de Diseño para Developers - Platzi</div>
                        <div className="item-lista"><FaCertificate className="icono-item" /> Curso de CSS Avanzado - Platzi</div>
                        <div className="item-lista"><FaCertificate className="icono-item" /> Curso de Grid Layout - Platzi</div>
                        <div className="item-lista"><FaCertificate className="icono-item" /> Curso de Transiciones y Transformaciones CSS - Platzi</div>
                        <div className="item-lista"><FaCertificate className="icono-item" /> Curso de Introducción al Backend - Platzi</div>
                        <div className="item-lista"><FaCertificate className="icono-item" /> Curso de SQL y MySQL - Platzi</div>
                        <div className="item-lista"><FaCertificate className="icono-item" /> Variables y estructuras de control en Python - SENA</div>
                    </div>
                </section>
            </main>
        </div>
    );
}

export default SobreMi;
